<template lang="pug">
  .welfare-center-container(
    :class="containerClass"
    :style="pageContainerStyle"
  )
    PageHeader(
      v-if="isApp"
      :pageTab="pageTab"
      :isMixPage="isMixPage"
      :styleVersion="styleVersion"
      :isHitchCarFare="isHitchCarFare"
      @changeTab="handleChangeTab"
    )

    .welfare-center-content(
      id="welfare-module-scroll-container"
      ref="content"
    )
      .page-title-area(v-if="!isApp")
        PageTitle(
          :titleIcon="pageConfig.titleIcon"
          :titleDesc="pageConfig.titleDesc"
          :pageKey="pageConfig.pageKey"
          :styleVersion="styleVersion"
        )
      .page-module-area(:style="pageModuleStyle")
        .bounty-notice(
          v-if="!isMixPage || pageConfig.componentName !== 'coupon-tab'"
          :style="noticeStyle"
        )
          BountyNotice(:styleVersion="styleVersion" :noticeData="noticeData")
        keep-alive(:include="['BountyTab', 'CouponTab']")
          component(
            ref="tabModule"
            :is="pageConfig.componentName"
            :styleVersion="styleVersion"
            :isMixPage="isMixPage"
            :isHitchCarFare="isHitchCarFare"
            @notice-data="handleNoticeData"
          )
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import { getPageConfig } from './common/helper';
import PageHeader from './welfare-center-cpns/page-header';
import PageTitle from './welfare-center-cpns/page-title';
import BountyTab from './bounty-tab';
import CouponTab from './coupon-tab/index.tsx';
import BountyNotice from './components/bounty-notice.vue';
import { WELFARE_CENTER_PAGE_KEY, WELFARE_VERSION } from './consts';

export default {
  components: {
    PageHeader,
    PageTitle,
    BountyTab,
    CouponTab,
    BountyNotice,
  },
  props: {
    // 页面样式版本
    styleVersion: {
      type: String,
      default: '',
    },
    // 是否为顺风车心智版本
    isHitchCarFare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 页面配置
      pageConfig: {},
      // 页面默认tab
      pageTab: WELFARE_CENTER_PAGE_KEY.bounty,
      // 是否是聚合页面
      isMixPage: false,
      // 是否是App端
      isApp: env.isEasyBikeApp,
      // 页面头部标题栏高度
      titleBarHeight: 0,
      // 公告数据
      noticeData: {},
    };
  },
  provide() {
    return {
      titleBarHeight: () => this.titleBarHeight,
      isWelfareApp: false,
    };
  },
  computed: {
    containerClass() {
      return {
        'self-scroll': this.needSelfScroll,
        'is-mini-tab': this.isMiniTab,
      };
    },
    pageContainerStyle() {
      const { bgImg } = this.pageConfig;
      return {
        backgroundImage: `url(${bgImg})`,
        backgroundPosition: this.isApp ? '0 0' : '0 -0.88rem',
        paddingTop: `${this.titleBarHeight / 100}rem`,
      };
    },
    pageModuleStyle() {
      const { pageKey } = this.pageConfig;
      if (this.isApp && this.isMixPage) {
        return {
          paddingTop: pageKey === WELFARE_CENTER_PAGE_KEY.coupon ? '0.58rem' : '0rem',
        };
      }
      return {
        paddingTop: this.isApp ? '0.0rem' : '0',
      };
    },
    noticeStyle() {
      if (this.isApp && this.isMixPage) {
        return {
          paddingTop: '0.17rem',
          paddingBottom: '0.01rem',
          marginBottom: this.noticeData && this.noticeData.noticeBoard ? '0.07rem' : '',
        };
      }
      return {
        paddingTop: '0.01rem',
        paddingBottom: '0.06rem',
      };
    },
    needSelfScroll() {
      const { pageKey } = this.pageConfig;
      return pageKey === WELFARE_CENTER_PAGE_KEY.coupon;
    },
    // 是否是小程序tab页
    isMiniTab() {
      const { isMiniTab } = this.$route.query || {};
      return isMiniTab === '1';
    },
  },
  created() {
    // 判断是否是聚合tab页面
    this.isMixPage = this.styleVersion === WELFARE_VERSION.NEW_TASK_SCENE_V4
      || this.styleVersion === WELFARE_VERSION.NEW_TASK_SCENE_V5;
    this.handlePageConfig();
  },
  mounted() {},
  methods: {
    // 处理页面配置
    handlePageConfig() {
      const { pageTab } = this.$route.query || {};
      this.pageTab = pageTab;
      this.handleChangeTab(pageTab);
    },
    // 处理tab切换
    handleChangeTab(key, type = '') {
      this.pageConfig = getPageConfig(key, this.isMixPage, this.isHitchCarFare);
      this.calcTitleBarHeight({
        pageKey: this.pageConfig.pageKey,
      });

      // 切换tab时，滚动到初始位置
      this.resetScrollPosition();

      // 切换tab => 告知子组件
      if (type === 'click') {
        const tabRef = this.$refs.tabModule;
        if (tabRef && typeof tabRef.onTabChange === 'function') {
          tabRef.onTabChange({ tabKey: key });
        }
      }
    },
    // 计算页面头部标题栏高度
    calcTitleBarHeight(options) {
      const { pageKey } = options || {};
      if (this.isApp) {
        if (pageKey === WELFARE_CENTER_PAGE_KEY.bounty) {
          this.titleBarHeight = this.isMixPage ? 125 : 88;
        } else {
          this.titleBarHeight = 88;
        }
      } else {
        this.titleBarHeight = 0;
      }
    },
    // 处理子组件上报的公告数据
    handleNoticeData(data) {
      this.noticeData = data || {};
    },
    // 重置滚动位置
    resetScrollPosition() {
      this.$nextTick(() => {
        const el = this.$refs.content;

        // coupon tab：容器自滚动
        if (el) {
          if (typeof el.scrollTo === 'function') {
            el.scrollTo({ top: 0, left: 0 });
          } else {
            el.scrollTop = 0;
          }
        }

        // 其它 tab：页面滚动
        if (window && typeof window.scrollTo === 'function') {
          window.scrollTo({ top: 0 });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.welfare-center-container {
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 0.12rem);
  padding-bottom: calc(env(safe-area-inset-bottom) + 0.12rem);
  width: 100vw;
  min-height: 100vh;
  background-color: #f0f3f5;
  background-size: 100% auto;
  background-position: 0 0;
  background-repeat: no-repeat;
  box-sizing: border-box;

  .page-title-area {
    padding: 0.14rem 0.16rem 0.14rem 0.2rem;
    position: relative;
    z-index: 4;
  }

  &.self-scroll {
    padding-bottom: 0;
    max-height: 100vh;

    .welfare-center-content {
      flex: 1;
      overflow-y: auto;
    }
  }

  &.is-mini-tab {
    padding-bottom: 0;

    .welfare-center-content {
      padding-bottom: 0.8rem;
    }
  }
}
</style>
